import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import JoinCoordinator from "./Join";
import { makeUrl } from "../../../api/makeUrl";

const JoinCoordinatorContainer: React.FC = () => {
    const { state, dispatch, startJoin } = useAuthenticationStore();
    const { firstName, email, lastName, isLoading, serverError } = state;
    const navigate = useNavigate();

    const setEmail = (newEmail: string) => {
        dispatch({ type: "SET_EMAIL", payload: newEmail });
    };
    const setFirstName = (newFirstName: string) => {
        dispatch({ type: "SET_FIRST_NAME", payload: newFirstName });
    };
    const setLastName = (newLastName: string) => {
        dispatch({ type: "SET_LAST_NAME", payload: newLastName });
    };

    const navigateToLogin = () => {
        if (location.href.includes("/identityserver/")) {
            navigate("../" + AuthenticationViews.login);
        } else {
            location.href = makeUrl("~/");
        }
    };

    return (
        <JoinCoordinator
            firstName={firstName}
            lastName={lastName}
            email={email}
            isLoading={isLoading}
            serverError={serverError}
            navigateToLogin={navigateToLogin}
            startJoin={startJoin}
            setEmail={setEmail}
            setFirstName={setFirstName}
            setLastName={setLastName}
        />
    );
};

export default JoinCoordinatorContainer;
